import type { FaireProductEntity } from "../../entity_types/product";

export const p_zsrzgkqrpx: FaireProductEntity = {
  token: "p_zsrzgkqrpx",
  type: "product",
  name: "Birthstone Charm Necklace",
  brandToken: "b_7sddd34i",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/5145ddc4f88dd07bf3507f7bdaa459a3164f720f263a9b2edd0d3c96b3b64379.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/03da73bc4ac08cdd76c964fad227cc3ee0961b6d1a3e7f3db67172a3df1bed96.jpeg",
    "https://cdn.faire.com/fastly/541bea695ad2f6ad5d01550fd19aada6b771d528d47b93c5874e194f6b592dc1.jpeg",
    "https://cdn.faire.com/fastly/3f1295037dee2df4d6356fd8cdb937236d311dc5639e2b194b399942ff41ce28.jpeg",
    "https://cdn.faire.com/fastly/658ace8adeec4cfb2cbe7272f73e3bd2e8e91ee673af1f6900780a2af3610618.jpeg",
    "https://cdn.faire.com/fastly/6fadcf5d14d619b0b5cb5cc6088828e877230e197d1999f8be4fa56d7308beb6.jpeg",
    "https://cdn.faire.com/fastly/f4ece798305e75c447877a8206a322ffa86af2e5a05492b9efe04a332eb4024c.jpeg",
    "https://cdn.faire.com/fastly/0178df276e643abcafa9ef732c407c28618ac2969bdce808a83b819e87ec041b.jpeg",
    "https://cdn.faire.com/fastly/b2a988ab8c163088997c3eeba0e885f670d4b5afa7cba409bcf73768674d2a0c.jpeg",
    "https://cdn.faire.com/fastly/23ec182c8ee90bc5419528fa1d4726645da6ca0c405e1565559c594e8c375a6a.jpeg",
    "https://cdn.faire.com/fastly/25d2e1db00750ca0545d8f65cddc64b139d01c70c68372d2e6fb5815fa8b7ed1.jpeg",
    "https://cdn.faire.com/fastly/8d444475a95a23a1128c78e4043c839c7d3a4d209e13dfb980a2f93a15526f8a.jpeg",
    "https://cdn.faire.com/fastly/c216d7d837fddcc3bd4366dbe7b33fe29eb1334980a3a0212557b6d88aac8a59.jpeg",
    "https://cdn.faire.com/fastly/02cfaded9f3aae55d7e050dbd96cc9df0be00d3e27aa22f5b6630adfd5625f97.jpeg"
  ],
  priceDollars: 62.36,
  description: "Add a touch of personality to your look with the Birthstone Charm Necklace. Designed with elegant charm clusters in a single hue, this versatile necklace blends natural stones, simulated opals, and cubic zirconia to create a captivating accessory for everyday wear or special occasions.\n\nMaterial: Gold-plated brass, Cubic Zirconia, Simulated Opal, Natural Stone\nLength: Adjustable, 16–18 inches\nSKU: TN-3817 (G)\n\n*Does not have to be sold as birthstone ",
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:02.072Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
